/**
 * Tipo do log gravado pela execução da Tabela IBPT. Mesmos ids do catálogo db_motor_fiscal.ibpt_tipo_log_execucao.
 */
export enum IbptTipoLogExecucaoEnum {
  Erro = 1,
  Sucesso = 2,
  Aviso = 3,
}
